'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var stringStartsWith = {};

exports.__exports = stringStartsWith;
